import getPublicUrl from "@/libs/get-public-url";
import {
    AbsoluteCenter,
    AspectRatio,
    Avatar,
    Box,
    Flex,
    Image,
    Text,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Currency from "./Currency";
import FAIcon from "./FAIcon";
import Skeletons from "./Skeletons";

const VideoPreview = ({
  onClick,
  thumbnails,
  thumbnail,
  timestamp,
  showCreator,
  creator,
  price,
  showPrice,
  isLocked = false,
  isLive = false,
  viewerCount,
}) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const image = new window.Image();
    image.src = thumbnails || thumbnail;
    image.onload = () => setLoaded(true);
  }, [thumbnail, thumbnails]);
  if (!loaded) return <Skeletons.Video />;
  return (
    <Box color="white">
      <Box position="relative" role="button" onClick={onClick}>
        <AspectRatio ratio={9 / 16}>
          <Image loading="lazy" src={thumbnails} rounded={4} />
        </AspectRatio>
        <AbsoluteCenter>
          {isLocked ? (
            <FAIcon type="lock" fontSize="2xl" position="relative" m="auto" />
          ) : (
            <FAIcon type="play" fontSize="2xl" position="relative" m="auto" />
          )}
        </AbsoluteCenter>
        {showCreator && creator?.picture && (
          <Flex
            p={2}
            top={0}
            left={0}
            position="absolute"
            gap={1}
            align="center"
          >
            <Avatar src={getPublicUrl(creator?.picture)} size="sm" />
          </Flex>
        )}
        {isLive && (
          <Box
            position="absolute"
            top={2}
            right={2}
            bg="red.500"
            px={2}
            py={1}
            rounded="md"
            fontSize="xs"
            fontWeight="bold"
          >
            LIVE
          </Box>
        )}
        {viewerCount != null && (
          <Box
            position="absolute"
            bottom={2}
            right={2}
            bg="blackAlpha.700"
            px={2}
            py={1}
            rounded="md"
            fontSize="xs"
          >
            <FAIcon type="eye" mr={1} />
            {viewerCount}
          </Box>
        )}
      </Box>
      {showPrice && price != null && (
        <Flex align="center" gap={1} mt={1}>
          <Currency size={3} />
          <Text fontWeight="bold" fontSize="sm">
            {price || "免費影片"}
          </Text>
        </Flex>
      )}
      {timestamp && (
        <Text fontWeight="bold" fontSize="sm" mb={1}>
          {dayjs(timestamp).format("YYYY/MM/DD")}
        </Text>
      )}
    </Box>
  );
};

export default VideoPreview;
